import queryString from 'query-string';

const attemptRerouting = (location, navigate) => {
    const query = queryString.parse(location.search);
    const returnUrl = query.returnUrl;
    const pathname = location.pathname;

    if (returnUrl) {
        if (returnUrl.indexOf('auth') === -1) {
            window.location.href = returnUrl;
        } else {
            navigate(returnUrl);
        }
    }  else if (pathname.indexOf('auth') === -1 && pathname.indexOf('createProfile') === -1 &&
            pathname.indexOf('emailSubscriptions') === -1) {
        navigate('/auth/profile');
    }
};

export default {
    attemptRerouting
};
